// extracted by mini-css-extract-plugin
export default {"container":"redirect_page_container__yB2HK","text":"redirect_page_text__eeIuI","absolute_logo":"redirect_page_absolute_logo__jItq+"};